import PolicyLoading from "./PolicyLoading";

export default PolicyLoading;
